import { observer } from 'mobx-react';
import { ConfigProvider, Flex, Tooltip } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { matchPath, useLocation, useNavigate } from 'react-router';
import { Book, Gear, House, InfoCircle } from 'react-bootstrap-icons';
import React from 'react';
import styles from './index.module.scss';
import userStore from '../../../../stores/userStore';

export interface SidebarTab {
  key: string;
  label: string;
  icon: React.ReactNode;
  path: string;
  position: 'top' | 'bottom';
}

interface Props {
  isCollapsed: boolean;
}

const Sidebar = observer(({ isCollapsed }: Props) => {
  const tabs: SidebarTab[] = [
    { key: 'projects', label: 'Проекты', icon: <House />, path: 'projects', position: 'top' },
    { key: 'directory', label: 'Справочник', icon: <Book />, path: 'directory', position: 'top' },
    { key: 'faq', label: 'Инструкция', icon: <InfoCircle />, path: 'faq', position: 'top' },
  ];

  if (userStore.user?.isHost) {
    tabs.push({ key: 'admin', label: 'Управление', icon: <Gear />, path: 'admin', position: 'bottom' });
  }

  return (
    <Sider className={styles.sidebar} trigger={null} collapsible collapsed={isCollapsed}>
      <ConfigProvider theme={{ components: { Menu: { itemHeight: 34 } } }}>
        <Flex vertical justify="space-between" style={{ height: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>
          <Flex vertical>
            <Logo isCollapsed={isCollapsed} />
            <div className={styles.menu}>
              {tabs
                .filter((e) => e.position === 'top')
                .map((e) => (
                  <MenuItem key={e.key} item={e} isCollapsed={isCollapsed} />
                ))}
            </div>
          </Flex>

          <div className={styles.menu} style={{ marginBottom: 12 }}>
            {tabs
              .filter((e) => e.position === 'bottom')
              .map((e) => (
                <MenuItem key={e.key} item={e} isCollapsed={isCollapsed} />
              ))}
          </div>
        </Flex>
      </ConfigProvider>
    </Sider>
  );
});

export default Sidebar;

const MenuItem = observer(({ item, isCollapsed }: { item: SidebarTab; isCollapsed: boolean }) => {
  const nav = useNavigate();
  const location = useLocation();

  const onSelect = () => nav(`/${item.path}`, { replace: true });

  const isActive = matchPath({ path: `/${item.path}`, end: false }, location.pathname);

  return (
    <Tooltip title={isCollapsed ? item.label : ''} placement="left" key={item.key}>
      <div
        style={{ width: isCollapsed ? 45 : '100%' }}
        key={item.key}
        onClick={onSelect}
        className={isActive ? styles.itemSelected : styles.item}
      >
        <div className={styles.label}>
          <div style={{ paddingTop: 2 }}>{item.icon}</div>
          <div style={{ opacity: isCollapsed ? 0 : 1 }} className={styles.title}>
            {item.label}
          </div>
        </div>
      </div>
    </Tooltip>
  );
});

const Logo = observer(({ isCollapsed }: { isCollapsed: boolean }) => {
  const nav = useNavigate();

  const goHome = () => nav('/projects');

  return (
    <div className={styles.logo} onClick={goHome}>
      <div className={styles.logoSystemLg} style={{ opacity: isCollapsed ? 0 : 1 }}>
        <div className={styles.textLogo}>
          <span className={styles.stafflow}>Stafflow</span>
          <span className={styles.badge}>360</span>
        </div>
      </div>
      <div className={styles.logoSystemSm} style={{ opacity: isCollapsed ? 1 : 0 }}>
        360
      </div>
    </div>
  );
});
